/**
 * HNB-575: rewrite vague contact link text in FAQ / rich text.
 * Merchant metafields often use "here" for #offCanvasContact.
 */
(function () {
  function improveContactLinks(root) {
    var scope = root || document;
    var links = scope.querySelectorAll('a[href="#offCanvasContact"], a[href*="#offCanvasContact"]');
    links.forEach(function (a) {
      var text = (a.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^here$/i.test(text) || /^click here$/i.test(text) || /^this link$/i.test(text)) {
        a.textContent = 'contact us';
      }
      var title = (a.getAttribute('title') || '').trim();
      var name = (a.textContent || '').replace(/\s+/g, ' ').trim();
      if (title && title.toLowerCase() === name.toLowerCase()) {
        a.removeAttribute('title');
      } else if (title && /^contact$/i.test(title) && /^contact us$/i.test(name)) {
        a.removeAttribute('title');
      } else if (title && /^here$/i.test(text)) {
        a.removeAttribute('title');
      }
    });
  }

  function run() {
    improveContactLinks(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // FAQ accordion / metafield content can hydrate late
  document.addEventListener('shopify:section:load', run);
  setTimeout(run, 1500);
})();
